import { Component, OnInit } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router'; // Import ActivatedRoute
import { GstInvoiceService } from '../../../../Services/Invoice/gst-invoice.service';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';
import { NotificationService } from '../../../../Services/notification.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


@Component({
  selector: 'app-invoice-gst',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './invoice-gst.component.html',
  styleUrl: './invoice-gst.component.css',
  providers: [DecimalPipe]
})
export class InvoiceGstComponent implements OnInit {
  invoiceData: any; 
  isLoading: boolean = true;
  customizeData: any = this.getDefaultSettings();
  invoiceId!: string | null;
  customerMobile: any;

  constructor(
    private route: ActivatedRoute,
    private gstInvoiceService: GstInvoiceService,
    private customizeService:CustomizeService,
    private notification:NotificationService
  ) {}

  ngOnInit() {
    // Get ID from URL
    // this.customizeData = this.getDefaultSettings()
    this.getGstCustomizeData();
    this.invoiceId = this.route.snapshot.paramMap.get('id');
    if (this.invoiceId) {
      this.fetchInvoiceData(this.invoiceId);
    }
  }

  fetchInvoiceData(id: string) {
    this.isLoading = true;
    this.gstInvoiceService.getGstInvoice(id).subscribe((res: any) => {
      this.invoiceData = res.data;
      this.customerMobile = res.data.customer_mobile;
      this.isLoading = false;
    });
  }

  // Calculate Rate/Gram for the static row based on fetched data
  get calculatedRate(): number {
    const subTotal = parseFloat(this.invoiceData?.sub_total || 0);
    // You'll need logic for Quantity if it's not in the DB, 
    // or use the silver_rate if you add it to the DB later.
    return 0; 
  }

  printInvoice() {
    const printContents = document.getElementById('print-section')?.innerHTML;
    if (printContents) {
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // layout restore karne ke liye
    } // Recommended: use CSS @media print to hide buttons
  }

  getGstCustomizeData(){
    const firmId = Number(localStorage.getItem('firm_id'));
    const applySavedLayout = (settings: any) => {
      if (settings?.header) {
        this.customizeData = settings;
      }
    };

    if (!firmId) {
      return;
    }

    this.customizeService.getUserSettings(firmId).subscribe({
      next: (res: any) => {
        applySavedLayout(res?.data?.gst_invoice_layout_settings);
      },
      error: () => {
        // Keep default header so the printed invoice is never blank
      }
    });
  }

async sendInvoiceWhatsapp() {

  const original = document.getElementById('print-section');

  if (!original) return;

  // --------------------------------------------------
  // CLONE NODE
  // --------------------------------------------------

  const clone = original.cloneNode(true) as HTMLElement;

  // A4 in pixels @96dpi ≈ 794 x 1123
  const A4_WIDTH_PX = 794;
  const A4_HEIGHT_PX = 1123;

  clone.style.background = '#ffffff';
  clone.style.position = 'fixed';
  clone.style.left = '-99999px';
  clone.style.top = '0';
  clone.style.width = A4_WIDTH_PX + 'px';
  clone.style.height = A4_HEIGHT_PX + 'px';
  clone.style.margin = '0';
  clone.style.padding = '0';
  clone.style.boxSizing = 'border-box';

  document.body.appendChild(clone);

  // --------------------------------------------------
  // APPLY PRINT LAYOUT INLINE
  // --------------------------------------------------

  // Outer container
  const outer = clone.querySelector('.outer-border-container') as HTMLElement;
  if (outer) {
    outer.style.width = '100%';
    outer.style.height = '100%';
    outer.style.boxSizing = 'border-box';
  }

  // Inner container = flex column
  const inner = clone.querySelector('.inner-print-container') as HTMLElement;
  if (inner) {
    inner.style.height = '100%';
    inner.style.display = 'flex';
    inner.style.flexDirection = 'column';
  }

  // Push footer to bottom
  const footer = clone.querySelector('.invoice-footer') as HTMLElement;
  if (footer) {
    footer.style.marginTop = 'auto';
  }

  // --------------------------------------------------
  // FORCE RGB COLORS (kill OKLAB)
  // --------------------------------------------------

  clone.querySelectorAll('*').forEach(el => {

    const style = window.getComputedStyle(el);
    const node = el as HTMLElement;

    if (style.color.includes('oklab') || style.color.includes('oklch')) {
      node.style.color = 'rgb(0,98,105)';
    }

    if (style.backgroundColor.includes('oklab') || style.backgroundColor.includes('oklch')) {
      node.style.backgroundColor = '#ffffff';
    }

    if (style.borderColor.includes('oklab') || style.borderColor.includes('oklch')) {
      node.style.borderColor = 'rgb(0,98,105)';
    }

    node.style.boxShadow = 'none';
  });

  // --------------------------------------------------
  // CAPTURE LIKE PRINT
  // --------------------------------------------------

  const canvas = await html2canvas(clone, {
    scale: 2, // higher since A4 fixed
    useCORS: true,
    backgroundColor: '#ffffff'
  });

  document.body.removeChild(clone);

  // --------------------------------------------------
  // IMAGE → PDF (no crop needed now)
  // --------------------------------------------------

  const imgData = canvas.toDataURL('image/jpeg', 0.85);

  const pdf = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    compress: true
  });

  pdf.addImage(imgData, 'JPEG', 0, 0, 210, 297, undefined, 'FAST');

  // --------------------------------------------------
  // SEND TO BACKEND
  // --------------------------------------------------

  const blob = pdf.output('blob');

  const reader = new FileReader();

  reader.onloadend = () => {

    const payload = {
      invoice_id: this.invoiceId,
      pdf: reader.result,
      mobile: this.customerMobile,
      message: `Meena Sterling Silver.
Please find your invoice attached.
All our jewellery is crafted in 925 sterling silver with premium rhodium finishing.
Thank you for choosing Meena Sterling Silver.`
    };

    this.gstInvoiceService.sendGstInvoiceToWhatsapp(payload).subscribe({
      next: () => this.notification.showSuccess('Invoice sent', 'success'),
      error: err => this.notification.showError(err.error.message, 'error')
    });

  };

  reader.readAsDataURL(blob);
}


getDefaultSettings() {
    return {
      colors: {
        themeColor: '#006269', // Teal color from image
        outerBorder: '#006269',
      },
      header: {
        gstin: { text: 'GSTIN: 06ACEFM7839B1Z9', visible: true, color: '#006269' },
        taxInvoice: { text: 'TAX INVOICE', visible: true, color: '#000000' },
        firmTitle: { text: 'MEENA SILVER & CO', visible: true, color: '#006269', fontSize: 28 },
        address: { text: 'Ground floor, 199, Warn No 11, Masjid Wali Gali, Rania, Sirsa, Haryana', visible: true, color: '#4b5563' },
        pan: { text: 'PAN: ACEFM7839B', visible: true, color: '#000000' },
        mobile: { text: 'Mob: 86838 36136', visible: true, color: '#000000' },
        logo: { url: 'assets/images/minaseelver_logo.png', visible: true }
      },
      detailsLabels: {
        partyDetails: { text: 'Party Details:', visible: true, color: '#000000' },
        customerName: { text: 'CUSTOMER NAME', visible: true, color: '#000000' },
        customerAddress: { text: 'Customer Address', visible: true, color: '#94a3b8' },
        gstinUin: { text: 'GSTIN / UIN:', visible: true, color: '#000000' },
        invoiceNo: { text: 'Invoice No.', visible: true, color: '#000000' },
        dated: { text: 'Dated', visible: true, color: '#000000' },
        modeOfPay: { text: 'Mode of Pay', visible: true, color: '#000000' },
        partyMobile: { text: 'Party Mobile', visible: true, color: '#000000' },
        reverseCharge: { text: 'Reverse Charge', visible: true, color: '#000000' },
        placeOfSupply: { text: 'Place of supply', visible: true, color: '#000000' },
      },
      table: {
        headers: [
          { text: 'S.N.', visible: true },
          { text: 'Description of Item', visible: true },
          { text: 'HSN', visible: true },
          { text: 'Qty/Gm', visible: true },
          { text: 'Rate/Gm', visible: true },
          { text: 'Amount(₹)', visible: true }
        ],
        sampleItem: { text: 'Silver Ornaments', visible: true }
      },
      summary: {
        taxableAmount: { text: 'Taxable Amount', visible: true, color: '#000000' },
        cgst: { text: 'CGST @ 1.5%', visible: true, color: '#64748b' },
        sgst: { text: 'SGST @ 1.5%', visible: true, color: '#64748b' },
        total: { text: 'TOTAL', visible: true, color: '#000000' },
        adjustment: { text: 'Adjustment (Round Off)', visible: true, color: '#94a3b8' },
        grandTotal: { text: 'GRAND TOTAL', visible: true, color: '#006269', backgroundColor: '#ecfeff' }
      },
      footer: {
        termsTitle: { text: 'TERMS & CONDITIONS', visible: true, color: '#b91c1c' },
        termsList: [
          { text: '1. Goods once sold will not be taken back', visible: true },
          { text: '2. Goods once sold will not be taken back.', visible: true },
          { text: '3. Subject to RANIA jurisdiction only.', visible: true }
        ],
        forFirm: { text: 'For Meena Silver & Co.', visible: true, color: '#006269' },
        signatory: { text: 'AUTHORIZED SIGNATORY', visible: true, color: '#94a3b8' },
        bankInfo: { text: 'BANK DETAILS: HDFC BANK, RANIA A/C: 50200116332671, IFSC: HDFC0002327', visible: true, color: '#ffffff' },
        signature: { url: '', visible: false }
      }
    };
  }
}